import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App.tsx';
import './index.css';

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);

// Register service workers for PWA + push notifications
if ('serviceWorker' in navigator) {
  window.addEventListener('load', async () => {
    // 1. Register the main PWA service worker (generated by vite-plugin-pwa)
    try {
      const registration = await navigator.serviceWorker.register('/sw.js', { scope: '/' });

      // Check for updates periodically (every 60 minutes)
      setInterval(() => registration.update(), 60 * 60 * 1000);

      // Notify app when a new SW is waiting to activate
      registration.addEventListener('updatefound', () => {
        const newWorker = registration.installing;
        if (!newWorker) return;

        newWorker.addEventListener('statechange', () => {
          if (newWorker.state === 'installed' && navigator.serviceWorker.controller) {
            // New content available — prompt user to update
            window.dispatchEvent(new CustomEvent('nudge:sw-update', { detail: { registration } }));
          }
        });
      });
    } catch {
      // SW registration failed — app still works without it
    }

    // 2. Register Firebase messaging service worker (for background push notifications)
    try {
      await navigator.serviceWorker.register('/firebase-messaging-sw.js', {
        scope: '/firebase-cloud-messaging-push-scope',
      });
    } catch {
      // Firebase SW registration failed — push notifications won't work in background
    }
  });
}
